import { AppError } from './AppError.js';
import { CombinedError } from 'urql';
import 'react';
import '@tanstack/react-query';
import 'lodash-es';

/**
 * Error thrown when network offline condition is detected.
 */ class OfflineError extends AppError {
    constructor(){
        super({
            title: `It seems like you're offline`,
            message: 'Check your network connection, and then refresh your browser'
        });
        Object.setPrototypeOf(this, OfflineError.prototype);
    }
}
function isOfflineError(error) {
    return error instanceof OfflineError || /* fetch throws TypeError with failed to fetch message */ error instanceof TypeError && error.message === 'Failed to fetch' || /* urql throws CombinedError with failed to fetch message */ error instanceof CombinedError && error.message === '[Network] Failed to fetch';
}

export { OfflineError, isOfflineError };
//# sourceMappingURL=OfflineError.js.map
